if (!customElements.get('lf-personalization')) {
  customElements.define(
    'lf-personalization',
    class ProductPersonalization extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-photo-input]');
        this.fileName = this.querySelector('[data-file-name]');
        this.error = this.querySelector('[data-photo-error]');
        this.input?.addEventListener('change', () => this.validatePhoto());
      }

      validatePhoto() {
        const file = this.input.files?.[0];
        const maximumSize = 20 * 1024 * 1024;
        const allowedTypes = ['image/jpeg', 'image/png'];

        this.input.setCustomValidity('');
        this.error.hidden = true;
        this.error.textContent = '';
        this.fileName.textContent = file ? file.name : this.dataset.noFile || '';

        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
          this.showError(this.dataset.invalidFormat || '');
          return;
        }

        if (file.size > maximumSize) {
          this.showError(this.dataset.fileTooLarge || '');
        }
      }

      showError(message) {
        this.input.setCustomValidity(message);
        this.error.textContent = message;
        this.error.hidden = false;
        this.input.value = '';
        this.fileName.textContent = this.dataset.noFile || '';
      }
    }
  );
}
